<template>
  <div class="flex-y-center justify-between">
    <template v-for="(menuItem, index) in checkUserEmail" :key="index">
      <RouterLink
        :class="{
          '!bg-gray-250':
            location === menuItem?.route || location?.includes(menuItem?.name),
        }"
        :to="
          menuItem?.queryParams
            ? menuItem?.route +
              '?' +
              menuItem?.queryParams?.param +
              '=' +
              menuItem?.queryParams?.value
            : menuItem?.route
        "
        class="px-4 rounded-3xl transition-300 flex items-center group gap-3 h-12"
      >
        <i
          :class="[
            menuItem?.svgIcon,
            {
              '!text-dark':
                location === menuItem?.route ||
                location?.includes(menuItem?.name),
            },
          ]"
          class="text-2xl text-gray-450 group-hover:!text-dark transition-300"
        />
      </RouterLink>
    </template>
  </div>
</template>

<script setup lang="ts">
import { navigationMenu } from "@/data/menu";
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useAuthStore } from "@/modules/Auth/stores";

const route = useRoute();
const store = useAuthStore();

const user = computed(() => store.user);
const location = computed(() => route?.name);
const checkUserEmail = computed(() =>
  user.value.email === "misha.polvanov2706@gmail.com"
    ? navigationMenu?.filter(
        (el) => el.route !== "/plan" && el.route !== "/wallet",
      )
    : navigationMenu,
);
</script>

<style scoped></style>
